export * from './departamentos-lfixes.pipe';
export * from './formas-pgtos-lfixes.pipe';
export * from './integradoras-lfixes.pipe';
export * from './lojas-lfixes.pipe';
export * from './num-pedido.pipe';
export * from './produtos-lfixes.pipe';
export * from './redes-lfixes.pipe';
